import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import BarcodeIcon from "@mui/icons-material/CalendarViewWeek";
import CameraIcon from "@mui/icons-material/CameraAlt";
import gif from "./free-phone-animated-mockup.gif";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import productsLarge from './Products.home.large';

const Home = () => {
  const navigate = useNavigate();
  const [product, setProduct] = useState("");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (windowWidth >= 768) {
    if (product) {
      return (
        <productsLarge
        />
      );
    }
  }

  const handleEnterDown = (e) => {
    if (e.key === "Enter") {
      navigate(`/products/details/${product}`);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        paddingBottom: "40vh",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 15,
          right: 15,
        }}
      >
        <IconButton onClick={() => navigate("/products")}>
          <Icon icon="carbon:home" />
        </IconButton>
      </Box>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-start",
        }}
      >
        <div>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              color: "#EF4F26",
              fontWeight: "bold",
              marginBottom: 2,
            }}
          >
            Welcome!
          </Typography>
        </div>
        <div>
          <Typography
            variant="h5"
            sx={{
              textAlign: "left",
              display: "flex",
              color: "#205375",
              fontWeight: "bold",
              marginBottom: 3,
            }}
          >
            Scan your product to get started.
          </Typography>
        </div>
      </div>
      <TextField
        fullWidth
        value={product}
        variant="outlined"
        placeholder="Search"
        sx={{ marginBottom: "2vh" }}
        onChange={(e) => setProduct(e.target.value)}
        onKeyDown={handleEnterDown}
        InputProps={{
          endAdornment: (
            <IconButton
              onClick={() => navigate(`/products/details/${product}`)}
            >
              <SearchIcon sx={{ color: "#FF5722" }} />
            </IconButton>
          ),
        }}
      />
      <Grid container justifyContent="center" sx={{ display: "flex", gap: 2 }}>
        <Grid item>
          <Button
            variant="outlined"
            onClick={() => {
              navigate("/scannerTest");
            }}
            sx={{
              "@media (max-width: 768px)": {
                maxWidth: "19vh",
              },
              "@media (min-width: 769px)": {
                maxWidth: "20vh",
              },
              "@media (max-height: 730px)": {
                maxWidth: "25vh",
              },
              padding: 2,
              textTransform: "none",
              borderColor: "#E1F5FE",
              color: "#000",
              backgroundColor: "#E1F5FE",
              "&:hover": {
                borderColor: "#81D4FA",
                backgroundColor: "#B3E5FC",
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BarcodeIcon sx={{ marginRight: 1, color: "grey" }} />
            <div>
              <Typography
                variant="body2"
                component="span"
                sx={{ color: "#555555", marginRight: 0.5 }}
              >
                Scan with
              </Typography>
              {"\n"}
              <Typography
                component="span"
                sx={{ color: "#205375", fontWeight: "bold" }}
              >
                Barcode
              </Typography>
            </div>
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            onClick={() => {
              navigate("/camera");
            }}
            sx={{
              "@media (max-width: 768px)": {
                maxWidth: "19vh",
              },
              "@media (min-width: 769px)": {
                maxWidth: "20vh",
              },
              padding: 2,
              textTransform: "none",
              borderColor: "#E1F5FE",
              color: "#000",
              backgroundColor: "#F5F5F5",
              "&:hover": {
                borderColor: "#81D4FA",
                backgroundColor: "#B3E5FC",
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CameraIcon sx={{ marginRight: 1, color: "grey" }} />
            <div>
              <Typography
                variant="body2"
                component="span"
                sx={{ color: "#555555", marginRight: 0.5 }}
              >
                Scan with
              </Typography>
              {"\n"}
              <Typography
                component="span"
                sx={{ color: "#205373", fontWeight: "bold" }}
              >
                Camera
              </Typography>
            </div>
          </Button>

          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              width: "100%",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              "@media (max-width: 600px)": {
                padding: 1,
                bottom: "15vh",
              },
              "@media (min-width: 601px)": {
                bottom: "2vh",
                width: "100%",
              },
            }}
          >
            {/* <img
              src={gif}
              alt="...Loading"
              style={{
                maxWidth: "100%",
                height: "auto",
                width: "auto",
                maxHeight: "40vh",
              }}
            /> */}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home;
